"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AccountSelection_1 = require("./AccountSelection");
exports.default = AccountSelection_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/AccountSelection/index.js
// module id = 1717
// module chunks = 8